import React, { useState } from 'react';
import { Button } from '@urbantxt/button';
import NotesViewModal from '../NotesViewModal';
import styles from './NotesButton.module.scss';

interface NotesButtonProps {
  notes: string;
}

function NotesButton(props: NotesButtonProps) {
  const { notes } = props;
  const [showModal, setShowModal] = useState(false);

  const handleOpen = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <Button
        className={styles.button}
        appearance="primary"
        size="xs"
        onClick={handleOpen}
      >
        View Notes
      </Button>

      <NotesViewModal
        open={showModal}
        onClose={handleClose}
        notes={notes}
      />
    </>
  );
}

export default NotesButton;
